import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamation } from 'react-icons/fa';
import styled from 'styled-components';
import FormikFieldWrapper from '../../base/forms/formikFieldWrapper';
import FormikRadio from '../../base/forms/formikRadio';
import FormikRadioWrapper from '../../base/forms/formikRadioWrapper';
import { H4 } from '../../base/typography';
import * as StyledInstructionsToEmployee from './sendReceiptForm.styles';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
}

const Subtext = styled.div`
	margin: 1rem -1rem -1rem;
	padding: 1rem;
	background-color: ${({ theme }) => theme.colors.secondaryDark};
	font-size: 1.5rem;

	display: flex;
	align-items: center;
	svg {
		margin-right: 0.5rem;
	}
`;

const InstructionsToEmployee: FC<Props> = ({ values, setFieldValue }) => {
	const { t } = useTranslation('sendReceipt');

	const { hasReceipt } = values;
	return (
		<StyledInstructionsToEmployee.InstructionsWrapper>
			<StyledInstructionsToEmployee.RadioWrapper>
				<FormikRadioWrapper colorTheme="secondary">
					<FormikRadio id="Yes" name="hasReceipt" label={t('iHaveReceipt')} setFieldValue={setFieldValue} />
					<FormikRadio
						id="No"
						name="hasReceipt"
						label={t('iDontHaveReceipt')}
						setFieldValue={setFieldValue}
					/>
				</FormikRadioWrapper>
				<Subtext>
					<FaExclamation />
					{t('validReceipt')}
				</Subtext>
			</StyledInstructionsToEmployee.RadioWrapper>
			{hasReceipt === 'No' && (
				<>
					<H4 marginTop="2rem" marginBottom="2rem">
						{t('instructions')}
					</H4>
					<FormikFieldWrapper name="instructionsToStaff" languageComponent="sendReceipt">
						<FormikRadio
							id="openUp"
							name="instructionsToStaff"
							label={t('permissionToOpen')}
							margin-top="1rem"
							setFieldValue={setFieldValue}
						/>
						<FormikRadio
							id="gift"
							name="instructionsToStaff"
							label={t('gift')}
							setFieldValue={setFieldValue}
						/>
						<FormikRadio
							id="other"
							name="instructionsToStaff"
							label={t('other')}
							setFieldValue={setFieldValue}
						/>
					</FormikFieldWrapper>
				</>
			)}
		</StyledInstructionsToEmployee.InstructionsWrapper>
	);
};

export default InstructionsToEmployee;
